import React from 'react'
import {BsDownload} from "react-icons/bs";


const DownloadRow = ({title, region, link}) => {
    return (
        <div className="text-center md:text-left mx-auto py-5 px-3 border-1 border-gray-dark block md:flex items-center justify-between">
            <div className="text-left w-full mb-8 md:mb-0">
                <span className="uppercase text-gray-text font-light text-xs xl:text-sm">
                    {title}
                </span>
                <h3 className="uppercase font-extrabold uppercase text-xl xl:text-2xl text-red-primary">
                    {region}
                </h3>
            </div>

            {/* //download button */}

            <a href={link} target = "_blank" className="transition hover:bg-white border-1 border-blue-primary hover:text-blue-primary w-44 mx-auto text-gray-light text-lg md:text-xl font-light bg-blue-primary py-1 px-8 rounded-full flex justify-center items-center space-x-4">
                <p>PDF</p> <BsDownload />
            </a>
        </div>
    )
}

export default DownloadRow
